<template>
    <div>
        <Modal id="modalM" v-model="modalR" class="scrollbar"
          :closable="false" :mask-closable="false" fullscreen footer-hide style="padding: 0px;"> 
            <wave ref="wave"/>
             <!--Modal id="modalR" v-model="modalR" :width="250" :styles="modalStyle"
              :closable="false" :mask-closable="false" draggable footer-hide>
                <Form>
                    <FormItem>
                        <Input v-model="token"></Input>
                    </FormItem>    
                    <FormItem>
                        <Button type="info" size="large" long :loading="isLoadingButton" @click="verification">验证</Button>
                    </FormItem>  
                </Form>
            </Modal-->
            <Form :style="modalStyle">
                <FormItem>
                    <Input v-model="token"></Input>
                </FormItem>    
                <FormItem>
                    <Button type="info" size="large" long :loading="isLoadingButton" @click="verification">验证</Button>
                </FormItem>  
            </Form>
        </Modal>
    </div>
</template>
<script>
    import wave from "../views/threejs/wave.vue";
    export default {
        components:{wave},
        computed: {
            modalStyle() {
                var style = {};
                var width = 300;
                style.position = "absolute";
                style.top = this.height * 0.6 + 'px';
                style.left = (this.width - width) * 0.5 + 'px';
                style.width = width + 'px';
                return style;
            }
        },
        mounted(){
            $("div.ivu-modal-body").addClass("scrollbar");
        },
        data(){
            return{
                modalR: true,
                isLoadingButton: false,
                token: "",
                width: window.innerWidth,
                height: window.innerHeight
            }
        },
        methods:{
            verification(){
                var that = this;
                that.isLoadingButton = true;
                //请求设备基础数据
                $.ajax({
                    url: "/api/verification",
                    contentType: "application/json",
                    type: "post",
                    data: that.token,
                    dataType: "json",
                    success: function(data) {
                        if(data.errorCode != 0) {
                            that.$Notice.error({
                                title: "异常",
                                desc: data.errorInfo
                            });
                            that.isLoadingButton = false;
                            return;
                        }
                        if (data.body == true) {
                            that.$Notice.success({
                                title: "成功",
                                desc: "验证通过"
                            });
                            that.modalR = false;
                        } else {
                            that.$Notice.error({
                                title: "失败",
                                desc: "验证不通过"
                            });
                        }
                        that.isLoadingButton = false;
                    },
                    error: function(textStatus) {
                        that.$Notice.error({
                            title: "异常",
                            desc: "接口请求异常"
                        });
                    }
                });
                
            }
        }
    }
</script>

<style scoped>
    #modalM /deep/ .ivu-modal-body {
        padding:0px;
    }
    #modalR /deep/ .ivu-modal-content{
        background-color:#ffffff00;
        box-shadow: 0 0px 0px rgba(0, 0, 0, 0);
    }
    
    /*自定义滚动条*/ 
    .scrollbar { 
    overflow-x: auto; 
    overflow-y: auto; 
    } 
    .scrollbar::-webkit-scrollbar { 
    width: 0px; 
    } 
</style>
